import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { ACCOUNTS_URL, REST_API_REQUEST_CALL_URL, Util } from "../utils/index";
import { Session } from "../models/index";
import { AlertService } from "./index";
import { Router } from "@angular/router";
import { ApiService } from "../services/api.service";

import "rxjs/Rx";
import { CookieService } from "ngx-cookie-service";

export class loginReqModel {
  email: string;
  password: string;
  rememberMe: boolean;
}

@Injectable()
export class AuthenticationService {
  constructor(
    private http: Http,
    private alertService: AlertService,
    private router: Router,
    private apiService: ApiService,
    private cookieService: CookieService
  ) {}

  getLogin(params: loginReqModel): Observable<Session> {
    return this.apiService
      .get(REST_API_REQUEST_CALL_URL.LOGIN_URL, params)
      .map((body) => {
        if (body.result) {
          let data = body.data;

          if (data.userTp != "99") {
            this.alertService.error("접속 권한이 없는 사용자입니다.");
            return false;
          }

          var role = data.userTp == "99" ? "consultant" : "guest";
          let profile = {
            displayName: data.email,
            id: data.userId,
            provider: "local",
            username: data.email,
            work: 50,
            role: role,
            corporation: data.corporation,
            remember: params.rememberMe,
          };

          localStorage.setItem("currentUser", JSON.stringify(profile));
          localStorage.setItem("token", data.token);
          return data;
        }
      });
  }
  logout() {
    this.apiService
      .post(REST_API_REQUEST_CALL_URL.LOGOUT_URL)
      .subscribe((res) => {});
    localStorage.removeItem("currentUser");
    localStorage.clear();

    this.apiService.redirectAccountLogin();
  }

  session(): Observable<any> {
    return this.apiService.get("session");
  }
}



// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts